export const iOS =
	(!global.process || global.process.browser) &&
	/iPad|iPhone|iPod/.test(navigator.userAgent);

export const iMac =
	(!global.process || global.process.browser) &&
	/Macintosh/.test(navigator.userAgent);
